<template>
  <div class="card-payment-container">
    <div class="row" v-if="stripeError">
      <div class="col">
        <div id="card-errors" class="text-danger mt-1">
          {{ stripeError }}
        </div>
      </div>
    </div>
    <div ref="cardNumber" class="form-control form-control-lg form-control-xl overflow-hidden"></div>
    <div class="row sm-gutters mx-n1 mt-2 mb-3 overflow-hidden">
      <div class="col px-1">
        <div ref="cardExpiry" class="form-control form-control-lg form-control-xl"></div>
      </div>
      <div class="col px-1">
        <div ref="cardCvc" class="form-control form-control-lg form-control-xl"></div>
      </div>
      <div class="col px-1">
        <input
          v-model="zip"
          maxlength="5"
          type="text"
          class="form-control form-control-lg form-control-xl"
          placeholder="Zip Code"
          name="zip"
        />
      </div>
    </div>
    <button @click="submit" class="btn btn-block btn-primary btn-lg btn-xl" :disabled="isSubmitting">
      <font-awesome-icon v-if="isSubmitting" icon="spinner-third" spin />
      <span v-else>{{ ctaText }}</span>
    </button>
  </div>
</template>

<script>
/*global Stripe*/
/*eslint no-undef: "error"*/
import { mapState } from 'vuex'
import { PracticeApi } from '@/services'
export default {
  props: {
    ctaText: {
      type: String,
      default: 'Upgrade now',
    },
    planId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      zip: null,
      elements: null,
      stripe: null,
      stripeError: null,
      isSubmitting: false,
      isPaymentComplete: false,
      styles: {
        base: {
          color: '#012b30',
          fontWeight: '500',
          fontFamily: '"Plus Jakarta Sans", sans-serif',
          fontSize: '1rem',
          lineHeight: '1.5',
          fontSmoothing: 'antialiased',
          height: 'calc(1.5em + 1.5rem + 2px)',
          padding: '0.75rem 1.25rem',

          ':focus': {
            color: '#012b30',
          },

          '::placeholder': {
            color: '#8c9797',
            fontWeight: 'normal',
          },

          ':focus::placeholder': {
            color: '#8c9797',
            fontWeight: 'normal',
          },
        },
        invalid: {
          color: '#d74e4e',
          ':focus': {
            color: '#d74e4e',
          },
          '::placeholder': {
            color: '#d74e4e',
          },
        },
      },
    }
  },
  computed: {
    ...mapState('auth', ['user']),
  },
  created() {},
  mounted() {
    const exisitingStripeScript = document.getElementById('_stripe-checkout-script')
    if (exisitingStripeScript) this.initStripe()
    else {
      const script = document.createElement('script')
      script.id = '_stripe-checkout-script'
      script.src = 'https://js.stripe.com/v3'
      script.onload = this.initStripe
      document.querySelector('head').append(script)
    }
  },
  methods: {
    initStripe() {
      this.stripe = this.stripe || Stripe(process.env.VUE_APP_STRIPE_KEY)
      this.elements =
        this.elements ||
        this.stripe.elements({
          fonts: [{ cssSrc: 'https://refera.com/fonts/jakartaplus/jakarta.min.css' }],
        }) //todo:load jakartaplus font from refera.com
      const opts = {
        style: this.styles,
        classes: {
          focus: 'focus',
          empty: 'empty',
          invalid: 'invalid',
        },
      }
      this.elements.create('cardNumber', opts).mount(this.$refs.cardNumber)
      this.elements.create('cardExpiry', opts).mount(this.$refs.cardExpiry)
      this.elements.create('cardCvc', opts).mount(this.$refs.cardCvc)
    },
    async submit() {
      //loader
      this.isSubmitting = true
      // Use Stripe.js to create a token. We only need to pass in one Element
      // from the Element group in order to create a token. We can also pass
      // in the additional customer data we collected in our form.
      try {
        const { token, error } = await this.stripe.createToken(this.elements.getElement('cardNumber'), {
          address_zip: this.zip,
          address_country: 'US',
        })
        if (token) {
          await this.savePaymentResult(token.id)
        } else if (error) {
          this.stripeError = error.message
          //this.$forceUpdate() // Forcing the DOM to update so the Stripe Element can update.
        } else {
          throw 'Unexpected result from Stripe. No error nor token'
        }
      } catch (err) {
        this.$exception(err)
      }
      this.isSubmitting = false
    },
    async savePaymentResult(tokenId) {
      try {
        await PracticeApi.saveRelated(
          this.user.practice.id,
          `subscribe/${tokenId}/${this.planId}`,
          {},
          { anonymous: true, json: false }
        )
        this.$store.dispatch('practices/refreshCurrentUserPractice')
        this.$store.dispatch('billing/load') //get updated subscription
        this.$store.dispatch('referrals/load', true) //get updated subscription
        this.isPaymentComplete = true
        this.$emit('complete')
      } catch (err) {
        this.$helpers.handleApiError(this)(err)
      }
    },
  },
  beforeDestroy() {
    document.getElementById('_stripe-checkout-script')?.remove()
  },
}
</script>

<style lang="scss" scoped>
.card-payment-container {
  .form-control-xl {
    height: calc(1.5em + 1.5rem + 2px);
    padding: 0.75rem 1.25rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: 0.3rem;
  }
}
</style>